import React from "react";
import styled from "styled-components";

export default function PageNotFound() {
  return (
    <SectionLayout>
      <h1>404</h1>
      <h4>PAGE NOT FOUND</h4>
      <div
        className="Button"
        onClick={() => window.location.href = '/'}>
        Home
      </div>
    </SectionLayout>
  );
}

const SectionLayout = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-family: "Helvetica";
  gap: 1rem;
  h1 {
    font-size: 15vw;
    letter-spacing: 0.5rem;
    color: #FCD21D;
    margin: 0;
  };
  h4 {
    font-size: 3vw;
    margin: 0;
    margin-top: -3rem;
    color: #fff;
  };
  .Button {
    width: 15rem;
    height: 4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #FCD21D;
    font-size: 2rem;
    font-weight: 700;
    cursor: pointer;
    color: #001526;
    text-decoration: none;
    border-radius: 50px;
    &:hover {
      opacity: 0.9;
      transform: scale(0.98);  
    }
  };
`;